function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Mask, Path } from 'react-native-svg';
export function Photo({
  width = 31,
  height = 31,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "prefix__a",
    maskUnits: 'userSpaceOnUse',
    x: 0,
    y: 0,
    width: 31,
    height: 31
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.917.917h29.108V30.01H.917V.918z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement(G, {
    mask: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.157 3.104c-3.676 0-6.052 2.519-6.052 6.416v11.888c0 3.898 2.376 6.415 6.052 6.415h12.615c3.685 0 6.066-2.517 6.066-6.415V9.52c0-3.897-2.381-6.416-6.066-6.416H9.157zm12.615 26.907H9.157c-4.93 0-8.24-3.458-8.24-8.603V9.52c0-5.145 3.31-8.603 8.24-8.603h12.615c4.936 0 8.254 3.458 8.254 8.603v11.888c0 5.145-3.318 8.603-8.254 8.603z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.702 23.055a1.091 1.091 0 01-.793-1.845l2.228-2.352a3.144 3.144 0 014.43-.133l1.396 1.418a1 1 0 001.413.016c.148-.174 3.324-4.031 3.324-4.031a3.54 3.54 0 012.402-1.278 3.57 3.57 0 012.601.795c.063.051.12.1 3.323 3.39a1.092 1.092 0 11-1.567 1.525s-2.988-3.067-3.2-3.274c-.227-.185-.59-.293-.947-.258a1.36 1.36 0 00-.922.491c-3.39 4.111-3.43 4.15-3.485 4.205a3.186 3.186 0 01-4.5-.047s-1.357-1.377-1.38-1.404c-.337-.313-.938-.292-1.298.088l-2.232 2.353a1.09 1.09 0 01-.793.341zM10.48 9.855a1.465 1.465 0 10.004 2.93 1.465 1.465 0 00-.004-2.93zm.002 5.117A3.657 3.657 0 016.83 11.32a3.655 3.655 0 013.652-3.652 3.658 3.658 0 013.653 3.652 3.658 3.658 0 01-3.653 3.653z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Photo.js.map